/**
 * A fingerprint of an arena's playable content. The server puts it in the welcome message and a
 * client compares it with the sidecar it loaded, so a stale or edited arena file can never run a
 * match against a server that stepped a different one. Both sides hash the parsed sidecar (with
 * schema defaults applied) in canonical key order, so formatting never matters.
 */
import { hashString, stableStringify } from '../combat/hash.js';
export function hashArena(def) {
    return hashString(stableStringify(def));
}
//# sourceMappingURL=hash.js.map